export interface InteractionOfferingDescriptionProps {
	resourceName: string;
	actionType: OfferingSourceType;
}

export enum OfferingSourceType {
	Fallback = 0,
	Callback = 1,
	Park = 2,
	Transfer = 3,
}
